import { Component, Input, OnInit } from '@angular/core';
import { AvailableServices, MeetingViewModelService } from '@vendasta/integrations';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'meeting-scheduler-connect-with-google-button',
  templateUrl: './connect-with-google-button.component.html',
  styleUrls: ['./connect-with-google-button.component.scss'],
  standalone: false,
})
export class ConnectWithGoogleButtonComponent implements OnInit {
  @Input() serviceKey: string;
  @Input() primaryDisconnect = true;
  signInText = this.translate.instant('MEETING_SCHEDULER.MEETING_INTEGRATIONS.GOOGLE_SIGN_IN');
  disconnectText = this.translate.instant('MEETING_SCHEDULER.MEETING_INTEGRATIONS.DISCONNECT_SERVICE');
  disconnectSecondaryText = this.translate.instant('MEETING_SCHEDULER.MEETING_INTEGRATIONS.DISCONNECT');
  alreadyConnectedText = this.translate.instant('MEETING_SCHEDULER.MEETING_INTEGRATIONS.CONNECTED');
  public readonly meet = AvailableServices.GOOGLE_MEET;
  isConnected$: Observable<boolean>;

  constructor(
    private readonly translate: TranslateService,
    private readonly meetingViewModelService: MeetingViewModelService,
  ) {}

  ngOnInit(): void {
    this.isConnected$ = this.meetingViewModelService.isServiceConnected$(AvailableServices.GOOGLE_MEET);
  }
}
